const SellingIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="220 154 203 209" {...props}>
    <path
      fill="#044acc"
      d="M221.023 180.389c0-12.253 9.691-22.188 21.643-22.188h156.909c11.955-.003 21.646 9.931 21.646 22.188v160.854c.003 12.256-9.688 22.191-21.643 22.191H242.669c-11.955.003-21.646-9.932-21.646-22.188V180.389Z"
    />
    <path
      fill="#fff"
      fillOpacity={0.9}
      d="M221.033 180.239a23.484 23.484 0 0 1 6.336-15.893c3.913-3.838 9.089-6.441 15.303-6.499l156.678.005c6.217.057 11.623 2.654 15.537 6.492 3.751 4.018 6.291 9.351 6.34 15.691l-.004 160.65a23.483 23.483 0 0 1-6.334 15.895c-3.913 3.839-9.089 6.442-15.305 6.5l-156.678-.005c-6.217-.057-11.623-2.654-15.537-6.492-3.751-4.019-6.291-9.352-6.34-15.691Z"
    />
    <path
      fill="#044acc"
      fillRule="evenodd"
      d="m318.219 207.37-40.578 7.552-8.655 40.309 3.441 3.476 55.298 56.689 47.923-49.127-57.432-58.899h.003Zm-40.671 45.462 7.069-30.759 30.978-6.061 48.995 50.254-36.865 37.791-47.046-48.229-3.128-2.996h-.003Zm55.261 22.441v-5.676h-13.032v-7.048h7.664v-4.634h-7.664v-4.088c0-3.089 1.908-4.997 4.608-4.997 1.729 0 3.456.866 4.432 2.319l4.786-3.864c-2.218-2.726-5.496-4.268-9.528-4.268-6.203 0-10.592 4.178-10.592 10.63v4.268h-2.79v4.634h2.79v7.042h-2.79v5.679h22.112l.004.003Zm-34.053-38.571c2.837-2.911 1.539-7.879-2.34-8.943a5.13 5.13 0 0 0-5.036 1.385c-2.837 2.912-1.539 7.879 2.34 8.944a5.13 5.13 0 0 0 5.036-1.386Z"
      clipRule="evenodd"
    />
    <path
      fillOpacity={0.4}
      fillRule="evenodd"
      d="m318.219 207.37-40.578 7.552-8.655 40.309 3.441 3.476 55.298 56.689 47.923-49.127-57.432-58.899h.003Zm-40.671 45.462 7.069-30.759 30.978-6.061 48.995 50.254-36.865 37.791-47.046-48.229-3.128-2.996h-.003Zm55.261 22.441v-5.676h-13.032v-7.048h7.664v-4.634h-7.664v-4.088c0-3.089 1.908-4.997 4.608-4.997 1.729 0 3.456.866 4.432 2.319l4.786-3.864c-2.218-2.726-5.496-4.268-9.528-4.268-6.203 0-10.592 4.178-10.592 10.63v4.268h-2.79v4.634h2.79v7.042h-2.79v5.679h22.112l.004.003Zm-34.053-38.571c2.837-2.911 1.539-7.879-2.34-8.943a5.13 5.13 0 0 0-5.036 1.385c-2.837 2.912-1.539 7.879 2.34 8.944a5.13 5.13 0 0 0 5.036-1.386Z"
      clipRule="evenodd"
    />
    <path
      d="M308.582 237.553h25.27v39.055h-25.27z"
      style={{
        stroke: "#e8effa",
        fill: "#e8effa",
        paintOrder: "fill",
        fillRule: "nonzero",
      }}
    />
    <text
      x={318.023}
      y={254.189}
      dx={-5.986}
      dy={12.814}
      style={{
        fill: "#09387a",
        fontFamily: "Arial,sans-serif",
        fontSize: 28,
        whiteSpace: "pre",
        transformOrigin: "319.633px 257.309px",
      }}
      transform="matrix(1.18288 0 0 .96449 -1.166 .744)"
    >
      {"\u20AC"}
    </text>
  </svg>
);
export default SellingIcon;
